import Vue from 'vue'
import { TagService} from '@/common/api.service'
import { SortUtils } from '@/common/utils.js'

import {
    FETCH_TAGS,
} from './actions.type'

import {
    SET_TAGS,
    RESET_STATE,
} from './mutations.type'

const initialState = {
    tags: []
}

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_TAGS] (context) {
        return TagService.get()
        .then(({ data }) => {
            let sortedData = SortUtils.sortAsc(data, {prop: 'name'})
            context.commit(SET_TAGS, sortedData)
        })
    },
}

export const mutations = {
    [SET_TAGS] (state, tags) {
        state.tags = tags
    },
    [RESET_STATE] () {
        for (let f in state) {
          Vue.set(state, f, initialState[f])
        }
    }
}

const getters = {
    tags (state) {
      return state.tags
    },
  }

export default {
    state,
    actions,
    mutations,
    getters
}